"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientInstance = getClientInstance;
const watch_1 = require("../watch");
const proxy_1 = require("../proxy");
const iframe_1 = require("./iframe");
const storage_1 = require("./storage");
let instance = false;
function getChannelFromParam(param) {
    return param.substring(param.indexOf('[') + 1, param.indexOf(']'));
}
function replayServerSideLogs(receivedBuffer) {
    if (!instance) {
        return;
    }
    const watchedChannels = storage_1.BrowserStorage.loadList();
    receivedBuffer.forEach((item) => {
        // eslint-disable-next-line no-console
        const callable = console[item.method];
        if (item.params.length > 0 && watchedChannels.length > 0) {
            const channel = getChannelFromParam(item.params[0]);
            if (watchedChannels.includes(channel)) {
                callable('[SSR]', ...item.params);
            }
        }
    });
}
function createInstance() {
    const watcher = new watch_1.ChannelWatch(storage_1.BrowserStorage);
    const { watch, unwatch, watching } = watcher;
    const proxy = new proxy_1.Proxy(console, watching);
    const { error, warn, info, log, trace, createLogger, list, alert, alertOnError, } = proxy;
    const selfLogger = proxy.createLogger('ddt');
    (0, iframe_1.initIframeSync)(selfLogger, watcher);
    return {
        watch,
        unwatch,
        watching,
        error,
        warn,
        info,
        log,
        trace,
        createLogger,
        list,
        replayServerSideLogs,
        alert,
        alertOnError,
    };
}
function getClientInstance() {
    if (!instance) {
        instance = createInstance();
        window.ddt = instance;
    }
    return instance;
}
//# sourceMappingURL=index.js.map